<template>
    <v-btn :to="to" text exact>{{ name }}</v-btn>
</template>

<script>
export default {
  props: ['to', 'name']
}
</script>

<style>

</style>